/* ber-image-banner.js — crossfade slideshow, luxury-grade */
(function () {
  'use strict';

  function BerSlideshow(section) {
    this.section   = section;
    this.slides    = Array.from(section.querySelectorAll('.ber-ib__slide'));
    this.dots      = Array.from(section.querySelectorAll('.ber-ib__dot'));
    this.prevBtn   = section.querySelector('.ber-ib__arrow--prev');
    this.nextBtn   = section.querySelector('.ber-ib__arrow--next');
    this.progBar   = section.querySelector('.ber-ib__progress-bar');
    this.current   = 0;
    this.count     = this.slides.length;
    this.timer     = null;
    this.progTimer = null;

    var autoplay = section.dataset.autoplay === 'true';
    this.speed   = parseInt(section.dataset.autoplaySpeed, 10) || 6000;
    this.trans   = parseInt(section.dataset.transition,    10) || 800;

    if (this.count < 2) return; // single slide — no JS needed

    this._bindEvents();
    if (autoplay) this._startAuto();
  }

  BerSlideshow.prototype._bindEvents = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self._stopAuto();
        self._go(self.current - 1);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self._stopAuto();
        self._go(self.current + 1);
      });
    }

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.dot, 10);
        if (idx === self.current) return;
        self._stopAuto();
        self._go(idx);
      });
    });

    // Pause on hover
    this.section.addEventListener('mouseenter', function () { self._stopAuto(); });
    this.section.addEventListener('mouseleave', function () {
      if (self.section.dataset.autoplay === 'true') self._startAuto();
    });

    // Touch / swipe
    var startX = null;
    this.section.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.section.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      self._stopAuto();
      self._go(dx < 0 ? self.current + 1 : self.current - 1);
    }, { passive: true });

    // Keyboard
    this.section.setAttribute('tabindex', '0');
    this.section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { self._stopAuto(); self._go(self.current - 1); }
      if (e.key === 'ArrowRight') { self._stopAuto(); self._go(self.current + 1); }
    });
  };

  BerSlideshow.prototype._go = function (idx) {
    var next = ((idx % this.count) + this.count) % this.count;
    if (next === this.current) return;

    var prev = this.current;
    this.current = next;

    // Crossfade
    this.slides[prev].classList.remove('ber-ib__slide--active');
    this.slides[prev].setAttribute('aria-hidden', 'true');
    this.slides[next].classList.add('ber-ib__slide--active');
    this.slides[next].setAttribute('aria-hidden', 'false');

    // Dots
    if (this.dots[prev]) {
      this.dots[prev].classList.remove('ber-ib__dot--active');
      this.dots[prev].setAttribute('aria-selected', 'false');
    }
    if (this.dots[next]) {
      this.dots[next].classList.add('ber-ib__dot--active');
      this.dots[next].setAttribute('aria-selected', 'true');
    }

    // Restart progress bar
    if (this.progBar && this.section.dataset.autoplay === 'true') {
      this._resetProgress();
    }
  };

  BerSlideshow.prototype._startAuto = function () {
    var self = this;
    this._resetProgress();
    this.timer = setInterval(function () { self._go(self.current + 1); }, this.speed);
  };

  BerSlideshow.prototype._stopAuto = function () {
    clearInterval(this.timer);
    this.timer = null;
    if (this.progBar) {
      this.progBar.style.transition = 'none';
      this.progBar.style.width = '0%';
    }
  };

  BerSlideshow.prototype._resetProgress = function () {
    if (!this.progBar) return;
    var self = this;
    // Reset instantly, then animate to 100% over the slide duration
    this.progBar.style.transition = 'none';
    this.progBar.style.width = '0%';
    // Force reflow before re-applying transition
    void this.progBar.offsetWidth;
    this.progBar.style.transition = 'width ' + (this.speed - this.trans) + 'ms linear';
    this.progBar.style.width = '100%';
  };

  // Init all slideshows on page
  function init() {
    document.querySelectorAll('.ber-image-banner-section .ber-ib').forEach(function (section) {
      new BerSlideshow(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
